import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { PATHS } from "@router/paths";

import Button from "@components/toolkit/Button/Button";
import Footer from "@components/layouts/shared/Footer/Footer";

import "./NotFound.scss";

const NotFound = () => {
  const navigate = useNavigate();

  const { t } = useTranslation(["notFound"]);

  const goToMainPage = () => navigate(PATHS.main.path);

  return (
    <div className="not-found">
      <img aria-hidden="true" src="/images/layouts/not-found-hero.png" alt="" className="not-found__hero-bg" />

      <header className="not-found__header">
        <button onClick={goToMainPage}>
          <img
            src="/images/branding/finder-ai-logo.png"
            alt="Finder AI"
            width={254}
            height={40}
            className="header-logo"
          />
        </button>
      </header>

      <main className="not-found__main">
        <h1 className="h2 green-1">{t("notFound:title")}</h1>

        <p className="p0">{t("notFound:description")}</p>

        <Button onClick={goToMainPage}>{t("notFound:goToMainPage")}</Button>
      </main>

      <Footer />
    </div>
  );
};

export default (
  <>
    <NotFound />
  </>
);
